import { CLEAR_CLAIMS, FETCH_CLAIMS_SUCCESS } from "../../../enums/Claims/Claims";


export const fetchClaimsSuccess = (claims) => ({
    type: FETCH_CLAIMS_SUCCESS,
    payload: claims,
});


export const clearClaims = () => ({
    type: CLEAR_CLAIMS,
});
